import { useCallback } from 'react';
import { useCalculatorContext } from '../contexts';
export function useProductClick() {
  var _useCalculatorContext = useCalculatorContext(),
    setSelectedProduct = _useCalculatorContext.setSelectedProduct;
  return useCallback(function (productId, idx) {
    setSelectedProduct({
      id: productId,
      idx: idx
    });
  }, [setSelectedProduct]);
}